<template>
  <div class="page-container">
    <div class="import-export-title primary-color import-export-title-margins">
      <v-icon color="secondary" class="arrow-back" @click="goBack()">arrow_back</v-icon>
      <span style="margin-left: 16px">{{ adminText('workflowsAll.export_attendees_70ca2c6', 'Export attendees') }}</span>
    </div>
    <v-select
      v-if="eventTemplateId"
      v-model="selectedEventId"
      :items="workflowUi(performanceDates)"
      :label="adminText('workflowsAll.performance_63c9045', 'Performance')"
      item-text="from"
      item-value="id"
      box
      style="max-width: 676px"
    />
    <div class="import-export-container import-export-container-margins">
      <div class="import-export-description-margins">
        {{ adminText('workflowsAll.you_can_export_your_attendees_and_all_of_thei_782cbb8', 'You can export your attendees and all of their data here. Choose the appropriate format of the file depending on the purpose.') }}
      </div>
      <div class="import-export-description-margins" style="margin-bottom: 0 !important">
        {{ adminText('workflowsAll.choose_format_f5deef5', 'Choose format:') }}
        <v-radio-group v-model="exportFormat">
          <v-radio color="primary" :label="adminText('workflowsAll.excel_a08e111', 'Excel')" value="xlsx" />
          <v-radio color="primary" label="CSV" value="csv" />
        </v-radio-group>
      </div>
      <div class="import-export-buttons">
        <a
          download
          :href="`${serverURL}/files/events/${
            eventId ? eventId : selectedEventId
          }/export/attendees/${exportFormat}/${
            token
          }?visible=${eventId ? visibleFields : theaterVisibleFields}`"
        >
          <main-button :disabled="disableExportingButton" depressed :text="adminText('workflowsAll.export_attendees_70ca2c6', 'Export attendees')" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import { encodeExportVisibleFields, getVisibleFields, serverURL } from '@/utils'
import { getExportToken } from '@/http'
import { GET_EVENTS_BY_EVENT_TEMPLATE_ID } from '@/graphql/event.graphql'
import moment from 'moment/moment'

export default {
  mixins: [WorkflowDisplay],
  name: 'theater-export-container',
  props: {
    eventTemplateId: {
      default: null,
      type: String,
    },
    eventId: {
      default: null,
      type: String,
    },
    organizationSlug: String,
  },
  data() {
    return {
      serverURL,
      token: undefined,
      exportFormat: 'xlsx',
      visibleFields: undefined,
      selectedEventId: null,
      performanceDates: [],
      disableExportingButton: false,
      theaterVisibleFields: encodeExportVisibleFields(['Attendee name', 'Email']),
    }
  },
  watch: {
    selectedEventId: {
      async handler(val) {
        this.disableExportingButton = true
        await this.getTokenAndVisibleFields(val)
        this.disableExportingButton = false
      },
    },
  },
  async created() {
    if (this.eventId) {
      await this.getTokenAndVisibleFields(this.eventId)
    }
  },
  methods: {
    async getTokenAndVisibleFields(eventId) {
      const { data } = await getExportToken(eventId)

      this.token = data.token
      const localStorageVisibleFields = getVisibleFields(eventId)
      this.visibleFields = encodeExportVisibleFields(localStorageVisibleFields)
    },
  },
  apollo: {
    getEventsByEventTemplateId: {
      query: GET_EVENTS_BY_EVENT_TEMPLATE_ID,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
          eventTemplateId: this.eventTemplateId,
        }
      },
      result({ data: { getEventsByEventTemplateId } }) {
        this.performanceDates = getEventsByEventTemplateId
          .map(p => {
            return { ...p, from: moment(p.from).format('DD.MM.YYYY u HH:mm') }
          })
        this.selectedEventId = this.performanceDates[0].id
      },
    },
  },
}
</script>

<style scoped></style>
